import React from "react";
import {Link} from "react-router-dom";
import Header from "./Header"

import styles from "./ProfilePageList.module.css";

function ProfilePageList(){
    return(
        <div className="profile-main">
            <Header />
            <div className={styles.nameList}>
                <h1 className = {styles.header}>Profile Pages</h1>
                <Link className={styles.name} to={'/AdavitaProfilePage'}>Adavita</Link>
                <br></br>
                <Link className={styles.name} to={'/JasonProfilePage'}>Jason</Link>
                <br></br>
                <Link className={styles.name} to={'/KevinProfilePage'}>Kevin</Link>
                <br></br>
                <Link className={styles.name} to={'/MichelleProfilePage'}>Michelle</Link>
                <br></br>
                <Link className={styles.name} to={'/NeemProfilePage'}>Neem</Link>
                <br></br>
                <Link className={styles.name} to={'/StyleGuidePage'}>Style Guide</Link>
            </div>

        </div>
    )
}

export default ProfilePageList;